import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import EquipmentTypeEditDialog from '../../Dialogs/Configuration/EquipmentTypeEditDialog';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function EquipmentTypesTable({ showEditDialog, includeDeleted, refresh }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(true);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getEquipmentTypes = async function () {
            let url = `api/v1/equipmenttype/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getEquipmentTypes();
    }, [fetchDataAuthenticated, includeDeleted, refresh]);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>);
            }
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        }
    ];

    const getRowProps = (row) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };

    return (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} initialState={{}} getRowProps={getRowProps} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );
}

function EquipmentTypeConfiguration() {

    const { businessUnits } = useBusinessUnits(false);

    const getNewEquipmentType = () => {
        return { equipmentTypeId: null, name: "", businessUnitId: null, isDeleted: false };
    };

    return (
        <CommonConfigPage
            title="Equipment Types"
            Table={EquipmentTypesTable}
            Dialog={EquipmentTypeEditDialog}
            getNewConfigObject={getNewEquipmentType}
            businessUnits={businessUnits}
        />
    );
}

export default EquipmentTypeConfiguration;